import { GridFilterInputValueProps } from '@mui/x-data-grid-pro';
import GroupsBigQueryMultiAutocomplete from '../../../shared/groups-bigquery-multi-autocomplete';
import Box from '@mui/material/Box';

function parseSelectedEmails(value: unknown): string[] {
  if (typeof value !== 'string' || value.length === 0) {
    return [];
  }
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function GroupsFilter(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const selectedEmails = parseSelectedEmails(item.value);

  const setSelectedEmails = (emails: string[]) => {
    applyValue({
      ...item,
      value: emails.length > 0 ? JSON.stringify(emails) : undefined,
    });
  };

  return (
    <Box sx={{ width: 320, py: 1 }}>
      <GroupsBigQueryMultiAutocomplete
        selectedEmails={selectedEmails}
        onChange={setSelectedEmails}
        size="small"
      />
    </Box>
  );
}
